import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'antd';

import { TaskContext } from '../Insurance';
import ModalFinishTask from './ModalFinishTask';
import { Task, TaskResponse, TaskState } from '../../../../gql/graphql';
import { useGetTaskResponsesByTask } from '../../../../services/task/querys';
import CardBorrowerImpersonation from '../../../CardBorrowerImpersonation/CardBorrowerImpersonation';
import SectionIssues from '../../../SectionIssues/SectionIssues';
import Contact from './Contact';
import Documents from './Documents';
import AnnouncementBasic from '../../../Atoms/Announcements/AnnouncementBasic';
import { SelectLoanDocumentContext } from 'scenes/Private/LoanDetails/LoanDetails';
import { formatMultiple } from '../insurance.utils';

interface Props {
  setStep: Function;
  closeTask: Function;
  responsesStep1?: any;
}

const Step2 = ({ setStep, closeTask, responsesStep1 }: Props) => {
  const [form] = Form.useForm();
  const { setLoanDocKey }: any = useContext(SelectLoanDocumentContext);
  const task: Task | any = useContext(TaskContext);

  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [modalFinishTask, setModalFinishTask] = useState<boolean>(false);
  const [responseInfo, setResponseInfo] = useState<TaskResponse | any>();
  const [responseDoc, setResponseDoc] = useState<TaskResponse | any>();

  useEffect(() => {
    getTaskResponses({ requestPolicy: 'network-only' });
  }, []);

  useEffect(() => {
    if (responseInfo && responseInfo.state !== TaskState.RequestError)
      form.setFieldsValue(responseInfo.metadata);
  }, [responseInfo])

  useEffect(() => {
    const _response = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-information');
    setResponseInfo(_response);

    const _response2 = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-doc');
    setResponseDoc(_response2);
  }, [taskResponses]);
  
  const isObie = responsesStep1 && responsesStep1?.find((item: any) => item.key === 'obie');
  const isContact = !!responseInfo;
  const isDocument = !!responseDoc;

  const announcement = {
    obie: {
      labelBold: 'The borrower has requested a quote from Obie. ',
      label: 'Follow up with them by email. Upload the final documents and then use the dropdown to control approval status',
    },
    contact: {
      labelBold: 'The borrower has given agent contact info. ',
      label: 'Contact the agent to get docs and upload them in loan documents',
    },
    multiple: {
      labelBold: `The borrower has selected multiple insurance options ${formatMultiple({ docs: isDocument, agent: isContact, obie: !!isObie })}. `,
      label: 'Review them with the borrower and upload the final docs',
    }
  }

  const selectedAnnouncement = isObie && !isContact && !isDocument? 
    announcement.obie: isContact && !isDocument && !isObie? 
      announcement.contact: announcement.multiple;

  return (
    <section className='insurance-step-2 '>
      <div className="section-1">
        <section>
          <h3 className="h3">
            {isContact && 'Who is your current insurance agent?'}
            {isDocument && 'Upload your insurance documents'}
          </h3>

          <div className="mt-10">
            <p className="description h4-w4">
              {isContact && 'We’ll reach out and get insurance documents. Before your insurance is approved, you can choose a different insurance type by reopening this task and choosing another option.'}
              {isDocument && 'Before your insurance is approved, you can choose a different insurance type by reopening this task and choosing another option.'}
            </p>
          </div>

          <CardBorrowerImpersonation hasResponses={taskResponses && taskResponses.length > 0} />
          <SectionIssues task={task} />

          {task.state === TaskState.Review && (isObie || isContact) && (
            <AnnouncementBasic
              className='title-review mt-20'
              text={
                <>
                  <span className='bold'>{selectedAnnouncement.labelBold}</span>
                  <span>{selectedAnnouncement.label}</span>
                </>
              }
              link={{
                label: 'Upload insurance docs here',
                onClick: () => setLoanDocKey('insurance'),
                className: 'link-review'
              }}
            />
          )}

          {isContact && <Contact />}
          {isDocument && <Documents />}
        </section>
      </div>

      <ModalFinishTask
        visible={modalFinishTask}
        setVisible={setModalFinishTask}
        closeTask={closeTask}
      />
    </section>
  );
};
export default Step2;
